(ns app.front.ui.label-group-state
  (:require [app.domain.label.model :as label-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

;;; =============================================================================
;;; Shared Label Data
;;; =============================================================================

(rf/reg-event-fx ::fetch-label-groups
  (fn [_ [_ authority-group-id]]
    {:dispatch [:comm/command-monitored {:command    :inspection/get-label-groups
                                         :method     :get
                                         :data       {:authority-group-id authority-group-id}
                                         :on-success [::entities/merge-entity-db]}]}))

(rf/reg-sub ::label-groups
  :<- [::entities/entities {:entity/type :entity.type/label-group}]
  (fn [all-groups [_ group-id]]
    (->> all-groups
         (filter #(= (-> % :domain/authority-group :db/id) group-id))
         (filter label-model/is-label-group?)
         (filter du/is-active?)
         (sort-by label-model/label-group-name))))

;;; =============================================================================
;;; State - Group Expansion
;;; =============================================================================

(rf/reg-sub ::expanded-group-ids
  :-> #(get % ::expanded-group-ids #{}))

(rf/reg-sub ::group-expanded?
  :<- [::expanded-group-ids]
  (fn [expanded-ids [_ group-id]]
    (contains? expanded-ids group-id)))

(rf/reg-event-db ::toggle-group-expanded
  (fn [db [_ group-id]]
    (update db ::expanded-group-ids util/toggle-in-set group-id)))

;;; =============================================================================
;;; State - Group Editing
;;; =============================================================================

(rf/reg-sub ::editing-group-id
  :-> ::editing-group-id)

(rf/reg-sub ::editing-group-name
  :-> #(get % ::editing-group-name ""))

(rf/reg-event-db ::set-editing-group
  (fn [db [_ group-id current-name]]
    (-> db
        (assoc ::editing-group-id group-id)
        (assoc ::editing-group-name (or current-name "")))))

(rf/reg-event-db ::set-editing-group-name
  (fn [db [_ name]]
    (assoc db ::editing-group-name name)))

(rf/reg-event-db ::cancel-editing-group
  (fn [db _]
    (-> db
        (dissoc ::editing-group-id)
        (dissoc ::editing-group-name))))

;;; =============================================================================
;;; State - Label Editing
;;; =============================================================================

(rf/reg-sub ::editing-label-id
  :-> ::editing-label-id)

(rf/reg-sub ::editing-label-name
  :-> #(get % ::editing-label-name ""))

(rf/reg-event-db ::set-editing-label
  (fn [db [_ label-id label-name]]
    (-> db
        (assoc ::editing-label-id label-id)
        (assoc ::editing-label-name (or label-name "")))))

(rf/reg-event-db ::set-editing-label-name
  (fn [db [_ name]]
    (assoc db ::editing-label-name name)))

(rf/reg-event-db ::cancel-editing-label
  (fn [db _]
    (-> db
        (dissoc ::editing-label-id)
        (dissoc ::editing-label-name))))

;;; =============================================================================
;;; State - New Label Input
;;; =============================================================================

(rf/reg-sub ::new-label-name
  (fn [db [_ group-id]]
    (get-in db [::new-label-names group-id] "")))

(rf/reg-event-db ::set-new-label-name
  (fn [db [_ group-id name]]
    (assoc-in db [::new-label-names group-id] name)))

(rf/reg-sub ::input-focused?
  (fn [db [_ group-id]]
    (get-in db [::input-focused group-id] false)))

(rf/reg-event-db ::set-input-focused
  (fn [db [_ group-id focused?]]
    (assoc-in db [::input-focused group-id] focused?)))

(rf/reg-event-db ::clear-new-label-input
  (fn [db [_ group-id]]
    (-> db
        (assoc-in [::new-label-names group-id] "")
        (assoc-in [::input-focused group-id] false))))

;;; =============================================================================
;;; State - New Group
;;; =============================================================================

(rf/reg-sub ::adding-group?
  :-> #(get % ::adding-group? false))

(rf/reg-sub ::new-group-name
  :-> #(get % ::new-group-name ""))

(rf/reg-event-db ::start-adding-group
  (fn [db _]
    (assoc db ::adding-group? true)))

(rf/reg-event-db ::set-new-group-name
  (fn [db [_ name]]
    (assoc db ::new-group-name name)))

(rf/reg-event-db ::cancel-adding-group
  (fn [db _]
    (-> db
        (dissoc ::adding-group?)
        (dissoc ::new-group-name))))
